<div class="login_sheet">
      <img src="../../../../assets/images/Logo_Orange_colorless.png" class="logo_login" alt="">
      <form action="" method="post">
                  <div class="notification error" *ngIf="errMsg">
                              {{errMsg | translate}}
                    </div>
            <div class="form_group">
                  <input type="text" #code class="with_email_icon" placeholder="{{'Reset Code' | translate}}">
            </div>
            <div class="form_group">
                  <input type="password" autocomplete="new-password" #password class="with_email_icon" placeholder="{{'New Password' | translate}}">
            </div>

            <div class="form_group">
                        <input type="password" #confirm class="with_email_icon" placeholder="{{'Confirm Password' | translate}}">
                  </div>
            <div class="form_group">
              <input (click)="onSubmit(code.value, password.value, confirm.value)" [disabled]="loading"
                     [value]="loading? 'loading...' : 'ENTER'" type="submit">
            </div>
        <div class="powered_by">{{'Copyright' | translate}} d.light {{currentYear}}</div>
      </form>
</div>
